import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function queryTaxIncome (params) {
  return request({
    ...APIS['@summaryIncome/Query_Tax_Income'],
    params
  })
}

export function querySubTaxIncome (params) {
  return request({
    ...APIS['@summaryIncome/Query_SubTaxIncome'],
    params
  })
}

export function queryNotTaxIncome (params) {
  return request({
    ...APIS['@summaryIncome/Query_NotTaxIncome'],
    params
  })
}

export function querySubNotTaxIncome (params) {
  return request({
    ...APIS['@summaryIncome/Query_SubNotTaxIncome'],
    params
  })
}

export function exportTaxIncome (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@summaryIncome/ExportTaxIncome'],
    params,
    headers,
    responseType
  })
}

export function exportNotTaxIncome (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@summaryIncome/Export_NotTaxIncome'],
    params,
    headers,
    responseType
  })
}
